import React from 'react'
import { PlanFeaturesRow } from '../PlanFeaturesRow/PlanFeaturesRow'
import {
  PlanFeaturesSectionHeader,
  PlanFeaturesSectionStyled,
  PlanFeaturesSectionContent,
} from './PlanFeaturesSection.styled'
import { TableSection } from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesTable'
import { CSS } from '@stitches/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleRight } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

type PlanFeaturesSectionProps = {
  data: TableSection[] | undefined
  title: string
  planToShow: number
  css?: CSS
}

export const PlanFeaturesSection = ({ data, title, planToShow, css }: PlanFeaturesSectionProps) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(true)

  const renderRows = () => {
    return data?.map((row, index) => {
      return (
        <PlanFeaturesRow
          title={row.title}
          tooltip={row.tooltip}
          cells={planToShow >= 0 ? [row.cells[planToShow]] : row.cells}
          key={index}
          cellCss={row.cellCss}
          featureNameCss={row.featureNameCss}
        />
      )
    })
  }

  return (
    <PlanFeaturesSectionStyled open={isOpen} onOpenChange={setIsOpen} css={css}>
      <PlanFeaturesSectionHeader>
        {title}
        <FontAwesomeIcon
          style={{ marginLeft: 'auto', paddingInline: '16px', width: '16px' }}
          icon={(isOpen ? faAngleDown : faAngleRight) as IconProp}
        />
      </PlanFeaturesSectionHeader>
      <PlanFeaturesSectionContent>{renderRows()}</PlanFeaturesSectionContent>
    </PlanFeaturesSectionStyled>
  )
}
